import { atom } from 'jotai';

const financeConfigurationAtom = atom<{ excludeOneOffPayments: boolean }>({
	excludeOneOffPayments: false,
});

export default financeConfigurationAtom;
